// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__9JCe3","imageUploader":"EGiftCard_imageUploader__2EhjP"};